export const TOGGLE_MENU_COLLAPSED = 'TOGGLE_MENU_COLLAPSED';



// WEBPACK FOOTER //
// src/modules/secured/constants/secured_constants.js